import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
    Button, Menu, makeStyles
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles((theme) => styles(theme));

export function MoreOptionsButton({ disabled, children }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
  
    function handleClick (event) {
      setAnchorEl(event.currentTarget);
    };
  
    function handleClose () {
      setAnchorEl(null);
    };
  
    return (
        <>
            <Button 
                classes={{ root: classes.buttonRoot }}
                variant="contained"
                color="secondary" 
                onClick={handleClick}
                disabled={disabled}
                fullWidth
            >
                <MoreVertIcon />
            </Button>
            <Menu
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {children}
            </Menu>
      </>
    );
}

const styles = theme => ({
    buttonRoot: {
        minWidth: 'auto',
        padding: 0,
        height: '100%'
    }
});

export default MoreOptionsButton;